// extracted by mini-css-extract-plugin
module.exports = {"nds-sup":"html-to-nds_nds-sup__dC3JD"};